import { FromPriceDisplay } from '../PriceDisplay';
import {
  CardWrapper,
  EditSearchLink,
  Label,
  LeftContent,
  Name,
  PriceWrapper,
  RightSection,
  SelectButton,
  TextContent,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  UnavailableText,
  UnavailableTextWrapper,
} from './ListItemCard.styles';
import type { ListItemCardProps } from './ListItemCard.types';

export function ListItemCard({
  name,
  label,
  image,
  price,
  buttonLabel = 'Select',
  onSelect,
  unavailable,
  unavailableLabel = 'Unavailable',
  editSearchLabel = 'Edit search',
  onEditSearch,
}: ListItemCardProps) {
  return (
    <CardWrapper $unavailable={unavailable} data-testid="list-item-card">
      <LeftContent>
        <Thumbnail>
          {image?.src ? (
            <ThumbnailImage src={image.src} alt={image.alt ?? name} />
          ) : (
            <ThumbnailPlaceholder data-testid="thumbnail-placeholder" />
          )}
        </Thumbnail>
        <TextContent>
          <Name>{name}</Name>
          {label && <Label>{label}</Label>}
        </TextContent>
      </LeftContent>

      <RightSection>
        {unavailable ? (
          <UnavailableTextWrapper>
            <UnavailableText>{unavailableLabel}</UnavailableText>
            {onEditSearch && (
              <EditSearchLink type="button" onClick={onEditSearch}>
                {editSearchLabel}
              </EditSearchLink>
            )}
          </UnavailableTextWrapper>
        ) : (
          <>
            {price && (
              <PriceWrapper>
                <FromPriceDisplay
                  amount={price.amount}
                  currencyCode={price.currencyCode}
                  label={price.label}
                  discount={price.discount}
                  locale={price.locale}
                  size="small"
                />
              </PriceWrapper>
            )}
            {onSelect && (
              <SelectButton type="button" onClick={onSelect}>
                {buttonLabel}
              </SelectButton>
            )}
          </>
        )}
      </RightSection>
    </CardWrapper>
  );
}
